export default "__VITE_ASSET__CqBgONKW__"